export const name = "Ukraine (Україна)"
export const iso2 = "ua"
export const dialCode = "380"
